import { Helmet } from 'react-helmet';
import {
  CompanyName,
  FULL_BUSINESS_URL,
  PageMediaHelper,
} from '../../utils/constants/Constants';
import getCanonical from '../../utils/seo/getCanonical'; // tiny helper below

export const HelmetItem = ({
  PageName,
  desc,
  keywords,
  canonicalPath = '/', // NEW: pass "/contact", etc.
  ogImage, // optional override
  additionalMeta = [],
  structuredData = null,
}) => {
  const schemaArray = Array.isArray(structuredData)
    ? structuredData
    : structuredData
    ? [structuredData]
    : [];
  const title = `${PageName} - ${CompanyName}`;
  const url = getCanonical(canonicalPath);
  const image =
    ogImage ||
    PageMediaHelper?.('servicesPreview') ||
    `${FULL_BUSINESS_URL}/og/default.jpg`;

  // If page didn't pass additionalMeta, fall back to sane defaults
  const baseSocial = [
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: title },
    { property: 'og:description', content: desc || '' },
    { property: 'og:url', content: url },
    { property: 'og:image', content: image },
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: desc || '' },
    { name: 'twitter:image', content: image },
  ];
  
  const metaFinal = [
    ...baseSocial, // ensure og:type  sane defaults
    ...(additionalMeta || []), // your page-specific OG/Twitter
  ];

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      {desc && <meta name='description' content={desc} />}
      {keywords && <meta name='keywords' content={keywords} />}

      {/* NEW: canonical link */}
      <link rel='canonical' href={url} />

      {metaFinal.map((m, i) => (
        <meta key={i} {...m} />
      ))}
      {schemaArray.map((data, i) => (
        <script key={i} type='application/ld+json'>
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
};
